import { Injectable, inject } from "@angular/core";

import { ModalOptions } from "@ionic/angular";
import { ModalController } from "@ionic/angular/standalone";

import { GenericComponent } from "../modals/generic/generic.component";
import { ModalBuildUpdateComponent } from "../modals/build-update/build-update.component";
import { ModalQrScannerComponent } from "../modals/qr-scanner/modal-qr-scanner.component";
import { BuildUpdateStatus } from "./helper-build-update-controller.service";

export interface BuildUpdateModalProps {
  mode: BuildUpdateStatus;
  title?: string;
  message?: string;
  currentVersion?: string;
  targetVersion?: string;
  storeUrls?: { android?: string; ios?: string };
}

const fallbackModalController: ModalController = {
  create: async () => ({
    present: async () => {},
    onDidDismiss: async () => ({ data: undefined, role: undefined }),
    dismiss: async () => true
  } as any),
  dismiss: async () => true
} as unknown as ModalController;

@Injectable({
  providedIn: 'root'
})
export class HelperModalControllerService {
  private modalController: ModalController = inject(ModalController, { optional: true }) || fallbackModalController;

  constructor() { }

  dismiss(data: Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>, role: string) {
    this.modalController.dismiss(data, role);
  }

  async modalGeneric(title: string, description: string) {
    const modal = await this.modalController.create({
      component: GenericComponent,
      componentProps: {
        _title: title,
        _description: description,
        _buttons: [
          {
            type: 'button',
            fill: 'solid',
            action: 'okay',
            label: 'Okay'
          }
        ]
      },
      cssClass: 'modal-generic',
      backdropDismiss: false
    } as ModalOptions);
    await modal.present();
    return modal;
  }

  async modalGenericSomethingWrong() {
    const modal = await this.modalController.create({
      component: GenericComponent,
      componentProps: {
        _title: 'Something Wrong',
        _description: 'Something Wrong! Try Again Later.',
        _buttons: [
          {
            type: 'button',
            fill: 'solid',
            action: 'okay',
            label: 'Okay'
          }
        ]
      },
      cssClass: 'modal-generic',
      backdropDismiss: false
    } as ModalOptions);
    await modal.present();
    return modal;
  }

  async modalBuildUpdate(props: BuildUpdateModalProps) {
    const isDismissible = props.mode === 'OPTIONAL_UPDATE';
    const modal = await this.modalController.create({
      component: ModalBuildUpdateComponent,
      componentProps: {
        mode: props.mode,
        title: props.title,
        message: props.message,
        currentVersion: props.currentVersion || '1.0.0',
        targetVersion: props.targetVersion || '1.0.0',
        storeUrls: props.storeUrls,
      },
      cssClass: 'modal-build-update',
      backdropDismiss: isDismissible,
    } as ModalOptions);
    await modal.present();
    return modal;
  }

  async modalQrScanner(): Promise<any> {
    const modal = await this.modalController.create({
      component: ModalQrScannerComponent,
      cssClass: 'modal-qr-scanner',
      backdropDismiss: true,
    } as ModalOptions);
    await modal.present();
    return modal;
  }
}
